import { Injectable } from '@angular/core';
import { ApiServiceProvider } from '../api-service/api-service';

/*
  Generated class for the PaymentServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PaymentServiceProvider {
  constructor(public apiService: ApiServiceProvider) {}

  pay(requestId, token, accountId) {
    return this.apiService.post('/payments', {
      requestId: requestId,
      token: token,
      accountId: accountId
    });
  }

  customerSource(data) {
    return this.apiService.post('/customerSource', data);
  }

  paymentsValidate(requestId) {
    return this.apiService.post('/paymentsValidate', { requestId });
  }
}



// WEBPACK FOOTER //
// ./src/providers/payment-service/payment-service.ts